/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CheckNetworkIngressHealthSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CheckNetworkIngressHealthRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type CheckNetworkIngressHealthSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CheckNetworkIngressHealthSecurity$outboundSchema: z.ZodMiniType<
  CheckNetworkIngressHealthSecurity$Outbound,
  CheckNetworkIngressHealthSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function checkNetworkIngressHealthSecurityToJSON(
  checkNetworkIngressHealthSecurity: CheckNetworkIngressHealthSecurity,
): string {
  return JSON.stringify(
    CheckNetworkIngressHealthSecurity$outboundSchema.parse(
      checkNetworkIngressHealthSecurity,
    ),
  );
}

/** @internal */
export type CheckNetworkIngressHealthRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const CheckNetworkIngressHealthRequest$outboundSchema: z.ZodMiniType<
  CheckNetworkIngressHealthRequest$Outbound,
  CheckNetworkIngressHealthRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function checkNetworkIngressHealthRequestToJSON(
  checkNetworkIngressHealthRequest: CheckNetworkIngressHealthRequest,
): string {
  return JSON.stringify(
    CheckNetworkIngressHealthRequest$outboundSchema.parse(
      checkNetworkIngressHealthRequest,
    ),
  );
}
